import { FC } from 'react';

import Column from 'components/Column';
import LegacyCard from 'components/LegacyCard';
import { NarrowCentredContent } from 'features/Onboarding/styles';

import locales from './locales';
import {
  BeneficiaryNextText,
  BeneficiarySubTitle,
  UnderReviewIcon as Icon,
  UnderReviewTitle as Title,
} from './styles';

const BeneficiaryKycContent: FC = () => (
  <LegacyCard>
    <LegacyCard.Body>
      <Column alignItems="center">
        <NarrowCentredContent>
          <Title>{locales.titleUnderReview}</Title>
          <BeneficiarySubTitle>
            <Icon name="timer" />
            {locales.delay}
          </BeneficiarySubTitle>
          <BeneficiaryNextText>
            {locales.beneficiaryNextText}
          </BeneficiaryNextText>
        </NarrowCentredContent>
      </Column>
    </LegacyCard.Body>
  </LegacyCard>
);

export default BeneficiaryKycContent;
